import { useMemo, useState } from 'react';
import { detectContentFormat, type ContentFormat } from '@/lib/contentFormat';

/** The format actually selected for display — any detected `ContentFormat`, or `'raw'` to show the unformatted source. */
export type ViewFormat = ContentFormat | 'raw';

/**
 * Detects a wiki article's or publication section's content format (see
 * `@/lib/contentFormat`) and tracks a reader-overridable selection on top
 * of it. The override also covers `'raw'` — viewing the exact,
 * unformatted source — which used to be a separate toggle button but is
 * now just another option in the same format selector (see
 * `ContentFormatSelect`).
 */
export function useContentFormat(content: string) {
  const detected = useMemo(() => detectContentFormat(content), [content]);
  const [override, setOverride] = useState<ViewFormat | undefined>();
  const selected: ViewFormat = override ?? detected;

  return { detected, selected, setSelected: setOverride };
}
